import { template0 } from './template0';
import { template1 } from './template1';
import { template2 } from './template2';
import { template3 } from './template3';

export interface Template {
  image: string;
  data: SimpleProjectServiceAPI.ConfigurationDataDto;
}

export const templates: Template[] = [
  { image: 'template0.png', data: template0 },
  { image: 'template1.png', data: template1 },
  { image: 'template2.png', data: template2 },
  { image: 'template3.png', data: template3 },
];

export const templatesByNameMap: Record<string, SimpleProjectServiceAPI.ConfigurationDataDto> = {
  'template-0': template0,
  'template-1': template1,
  'template-2': template2,
  'template-3': template3,
};
